module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-3d-fill-1307da4a.svg";